/** @format */

export default {
  setPractices(state, payload) {
    state.practices = payload;
  },
  setAllComplaints(state, payload) {
    state.allComplaints = payload;
  },
  setAllComplaintsCount(state, payload) {
    state.allComplaintsCount = payload;
  },
  setComplaint(state, payload) {
    state.complaint = payload;
  },
  refreshUpdates(state, payload) {
    state.complaint.complaint_update = payload;
  },
  grantExtension(state, payload) {
    // Update the current extension date
    state.complaint.complaint_acknowledgement.extension_date = payload.extension_date;
    state.complaint.complaint_acknowledgement.remaining_days =
      payload.remaining_days;
    
    // Update extension count
    state.complaint.extension_count = payload.extension_count || 
      (state.complaint.extension_count ? state.complaint.extension_count + 1 : 1);
    
    // Add to extension history if provided
    if (payload.extension_record) {
      if (!state.complaint.complaint_extensions) {
        state.complaint.complaint_extensions = [];
      }
      state.complaint.complaint_extensions.push(payload.extension_record);
    } else if (payload.complaint_extensions) {
      state.complaint.complaint_extensions = payload.complaint_extensions;
    }
  },

  setComplaintTypeStats(state, payload) {
    state.complaintTypeStats = payload;
  },

  setSubjectGroupStats(state, payload) {
    state.subjectGroupStats = payload;
  },
  setStaffGroupStats(state, payload) {
    state.staffGroupStats = payload;
  },

  setAgeGroupStats(state, payload) {
    state.ageGroupStats = payload;
  },
  setPatientRelationshipGroupStats(state, payload) {
    state.patientRelationshipGroupStats = payload;
  },

  setComplaintsAgainstPracticesStats(state, payload) {
    state.complaintsAgainstPracticesStats = payload;
  },
};
